export default {
    root: {
        class: [
            // Layout
            'tw-flex tw-flex-col tw-overflow-hidden',
        ],
    },
    contentContainer: {
        class: [
            // Layout & Scroll Behavior
            'tw-flex tw-flex-col tw-overflow-auto tw-h-full',
        ],
    },
    content: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Layout
                'tw-flex tw-h-full',
                // Orientation
                {
                    'tw-flex-row tw-justify-between': props.orientation !== 'vertical',
                    'tw-flex-col': props.orientation == 'vertical',
                },
                // Button Placement
                '[&>[data-pc-extend=button]]:tw-self-center',
            ],
        });
    },
    viewport: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Vertical orientation layout
                {
                    'tw-overflow-hidden tw-w-full tw-relative': props.orientation !== 'vertical',
                },
            ],
        });
    },
    itemList: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-flex tw-h-full',
                // Orientation
                {
                    'tw-flex-row': props.orientation !== 'vertical',
                    'tw-flex-col': props.orientation == 'vertical',
                },
            ],
        });
    },
    item: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-flex tw-shrink-0 grow tw-items-center',
                'tw-relative',
                {
                    'tw-w-full sm:tw-w-[50%] md:tw-w-2/4': props.orientation !== 'vertical' && props.numVisible !== 1,
                    'tw-flex tw-shrink-0 tw-grow tw-w-full tw-h-full tw-px-16 tw-pt-8 tw-pb-14': props.orientation !== 'vertical' && props.numVisible === 1,
                    'tw-w-full tw-h-full': props.orientation == 'vertical',
                },
            ],
        });
    },
    itemClone: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Flexbox
                'tw-flex shrink-0 grow',
                'tw-invisible',
                // Size
                {
                    'tw-w-full sm:tw-w-[50%] md:tw-w-2/4': props.orientation !== 'vertical' && props.numVisible !== 1,
                    'tw-flex tw-shrink-0 tw-grow tw-w-full tw-h-full': props.orientation !== 'vertical' && props.numVisible === 1,
                    'tw-w-full tw-h-full': props.orientation == 'vertical',
                },
            ],
        });
    },
    indicatorList: {
        class: [
            // Layout & Position
            'tw-flex tw-flex-row tw-justify-center tw-flex-wrap tw-mt-2 tw-z-10 tw-absolute tw-bottom-2 tw-left-2/4 tw--translate-x-2/4',
        ],
    },
    indicator: {
        class: [
            // Spacing
            'tw-mr-2 tw-mb-2',
        ],
    },
    indicatorButton: function (_a) {
        var context = _a.context;
        return ({
            class: [
                // Misc
                'tw-cursor-pointer',
                // Shape - make it a small dot
                'tw-rounded-full tw-w-2.5 tw-h-2.5',
                // Border
                'tw-border-0',
                // Focus Styles
                'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring focus:tw-ring-primary-400/50 dark:focus:tw-ring-primary-300/50',
                // Color & Background
                {
                    'tw-bg-gray-200 hover:tw-bg-gray-300 dark:tw-bg-gray-400 dark:hover:tw-bg-gray-500': !context.highlighted,
                    'tw-bg-primary-500 hover:tw-bg-primary-600': context.highlighted,
                },
            ],
        });
    },
    pcPrevButton: {
        root: {
            class: [
                // Positioning
                'tw-absolute tw-left-4',
                // Misc
                'tw-p-1.5 tw-z-10 tw-cursor-pointer',
                // Colors
                'tw-text-white tw-bg-primary-500 hover:tw-bg-primary-600',
                // Shape
                'tw-rounded-md',
                // Border
                'tw-border tw-border-transparent tw-border-0',
                // Focus Styles
                'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
                // Animation
                'tw-transition tw-duration-200 tw-ease-in-out',
            ],
        },
        label: {
            class: 'tw-hidden',
        },
    },
    pcNextButton: {
        root: {
            class: [
                // Positioning
                'tw-z-10 tw-absolute tw-right-4',
                // Interaction & Styling
                'tw-p-1.5 tw-cursor-pointer',
                'tw-text-white tw-bg-primary-500 hover:tw-bg-primary-600',
                // Shape
                'tw-rounded-md',
                // Border
                'tw-border tw-border-transparent tw-border-0',
                // Focus Styles
                'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
                // Animation
                'tw-transition tw-duration-200 tw-ease-in-out',
            ],
        },
        label: {
            class: 'tw-hidden',
        },
    },
};
